import * as React from "react";
import type {Report} from "../../../../../../data/models/Report";
import {useAppStore} from "../../../../../../StateManager";
import {DomPortal} from "../../../../../modules/abstract/portal/DomPortal";
import {FullscreenLoader} from "../../../../../../FullscreenLoader";
import {DynamicComponent} from "./DynamicComponent";

export interface IItem {
	readonly id: string;
	readonly name: string;
}

interface ICustomReportInputProps {
	readonly report: Report;
	readonly onClose: () => void;
}

export interface ICustomUserInput {
	readonly SpaceIDs: string[];
	readonly DepartmentNames?: string[]; // Optional, used for Kaiser Procurement Equipment Count report
	readonly XyiconTypeID?: string; // Optional, used for test report
	// Add additional fields as needed to accommodate varying report requirements
}

export const CustomReportInputV5: React.FC<ICustomReportInputProps> = (props) => {
	const appState = useAppStore((store) => store.appState);

	const getCustomInputFormNameByReport = (report: Report): string => {
		const customInputId = report.definition.entryPointParameters.reportIdentifier;

		switch (customInputId) {
			case "ProcurementCountsReportWithCustomInput":
				return "KaiserCustomInputsForReports";
			case "SutterDeploymentSheetReport":
				return "SutterDeploymentReportCustomInput";
			case "TestCustomInputReport":
				return "TestCustomInputsForReports";
			default:
				return "";
		}
	};

	const customInputComponentName = getCustomInputFormNameByReport(props.report);

	if (!customInputComponentName) {
		console.log("Custom input component not found!");
		return <></>;
	}

	return (
		<DynamicComponent
			url={customInputComponentName}
			report={props.report}
			fallback={
				<DomPortal destination={appState.app.modalContainer}>
					<FullscreenLoader text="Loading..." />
				</DomPortal>
			}
			onClose={props.onClose}
		/>
	);
};
